import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Hotel, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center bg-primary text-primary-foreground">
            <Hotel className="h-5 w-5" />
          </div>
          <span className="font-heading text-lg font-black tracking-tight">GCG HOTELS</span>
        </div>
        <h1 className="font-heading text-3xl font-black tracking-tight">Reset password</h1>
        {done ? (
          <p className="mt-4 text-sm text-muted-foreground" data-testid="forgot-done">
            If that email exists, a reset link has been generated. Check server logs (email delivery not yet configured).
          </p>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-form">
            <div className="space-y-1.5">
              <Label>Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
            </div>
            {error && <p className="text-sm text-destructive">{error}</p>}
            <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit">
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Send reset link
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 inline-block text-sm text-primary hover:underline">Back to sign in</Link>
      </div>
    </div>
  );
}
